import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ConstantsService } from './constants.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }

  uploadExcelFileASNExport(userID, excelFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', excelFile, excelFile.name)
    return this.http.post(`${this.constantsService.baseAPIURL}/Export/import/${userID}`, formData, { responseType: 'text' })
      .pipe(
        timeout(260000),
        catchError(this.handleError));
  }

  uploadExcelFileSAPVerification(userID, excelFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', excelFile, excelFile.name)
    return this.http.post(`${this.constantsService.baseAPIURL}/Export/home/import/sapverification/${userID}`, formData, { responseType: 'text' })
      .pipe(
        timeout(260000),
        catchError(this.handleError));
  }


  uploadExcelFileSAPImport(userID, excelFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', excelFile, excelFile.name)
    return this.http.post(`${this.constantsService.baseAPIURL}/Export/import/sap/${userID}`, formData, { responseType: 'text' })
      .pipe(
        timeout(260000),
        catchError(this.handleError));
  }

  downloadReport(userID) {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/export/genRep/${userID}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }

  sendMail(params: any): Observable<any> {
    console.info("params ", params.recipientList)
    const formData = new FormData();
    formData.append('fromList', JSON.stringify(params.fromList));
    formData.append('recipientList', JSON.stringify(params.recipientList));
    formData.append('subject', params.subject);
    formData.append('content', params.content);
    formData.append('attachments', new Blob([]), '');
    const token = sessionStorage.getItem('accessToken'); // Retrieve the access token
    return from(fetch(environment.SENDMAIL_URL, {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Authorization': token ? `Bearer ${token}` : ''
      },
      body: formData
    }))
      .pipe(catchError(this.handleError))
  }
}
